import { Controller } from "stimulus";

const SENT_DURATION_MS = 3000;
const STORAGE_KEY = "newsletter-resend-sent-at";

// "Resend email" -> "Sent!" for a few seconds. The form still submits normally; the server answers with a
// redirect and Turbo then swaps the whole subscribe frame, which would throw this element (and its timer)
// away, so the moment of the click is kept in sessionStorage and the fresh copy picks up the remainder.
export default class extends Controller {
  static targets = ["button", "sent"];

  connect() {
    const remaining = SENT_DURATION_MS - (Date.now() - this.sentAt());
    if (remaining > 0) this.showSent(remaining);
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  submit() {
    if (!this.sentTarget.hidden) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (_) {
      // Storage unavailable: the feedback still shows until the frame is swapped.
    }
    this.showSent(SENT_DURATION_MS);
  }

  showSent(duration) {
    this.buttonTarget.hidden = true;
    this.sentTarget.hidden = false;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.sentTarget.hidden = true;
      this.buttonTarget.hidden = false;
    }, duration);
  }

  sentAt() {
    try {
      return Number(sessionStorage.getItem(STORAGE_KEY)) || 0;
    } catch (_) {
      return 0;
    }
  }
}
